module.exports = __webpack_public_path__ + "img/0S6A9599.fd478d23.jpg";